export default function getShelfLinkProps(url, arenaUrl) {
  if (!url) {
    return { isExternal: false, to: "/" };
  }

  if (!url.startsWith("http")) {
    return { isExternal: false, to: url };
  }

  try {
    const linkUrl = new URL(url);
    const baseUrl = new URL(arenaUrl);

    if (linkUrl.origin === baseUrl.origin) {
      return {
        isExternal: false,
        to: `${linkUrl.pathname}${linkUrl.search}${linkUrl.hash}`,
      };
    }

    return { isExternal: true, href: url };
  } catch {
    return { isExternal: false, to: url };
  }
}
